module.exports = __webpack_public_path__ + "assets/img/home2-box2-3.cc47586c.png";